// extracted by mini-css-extract-plugin
export default {"link":"Link_link__LPcst","link__collapsed":"Link_link__collapsed__xFDUR","link__active":"Link_link__active__JN2s2"};